module.exports = __webpack_public_path__ + "static/media/image3.ba711b06.png";